import { render } from "./RestrictDialog.vue?vue&type=template&id=e8c5f7c2&ts=true&lang=pug"
import script from "./RestrictDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./RestrictDialog.vue?vue&type=script&lang=ts&setup=true"

import "./RestrictDialog.vue?vue&type=style&index=0&id=e8c5f7c2&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__